
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ApproveemployeepopupComponent } from './approveemployeepopup/approveemployeepopup.component';
import { AddProgramComponent } from './add-program/add-program.component';
import { FacultyNamePopupComponent } from './faculty-name-popup/faculty-name-popup.component';
@Component({
  selector: 'app-training-calendor',
  templateUrl: './training-calendor.component.html',
  styleUrls: ['./training-calendor.component.scss'],
})
export class TrainingCalendorComponent implements OnInit {
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedYearForCompetency: any = null;
  pmsYears: any = [];
  programForm!: FormGroup;
  selectedTabIndex: number = 0;  // Default tab is "Create Calendar"
  selectedTypeTabIndex: number = 0;
  selectedTypeTabName = 'createcalendar'
  buttonColorName: any;
  showSetupPopup: boolean = false;
  getProgramme: any;
  searchTerm: any;
  loggedInUserName: any;
  constructor(private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService,) {
    this.programForm = this.fb.group({
      selectedProgram: [''] // Default empty selection
    });
  }


  ngOnInit() {
    this.selectedTypeTabName = "createcalendar";
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getpmsyearlist();
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);
    });
  }



  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getAllProgramme();
      this.getAllNominatedEmp();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  getYearSetupForReimbursement(year: any) {
    this.selectedYearForCompetency = year;
    console.log(this.selectedYearForCompetency);
    this.selectedYear = year;
  }



  selectTab(tab: string) {
    this.selectedTypeTabName = tab;
  }



  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/lnd-setup', { operation: operation }]);
  }


  onClickback() {
    this.router.navigate(['/home/hrportal/lnd']);
  }


  openDialog(message: string, buttonText: string = 'OK', buttonColor: string = 'red', showSuccessIcon: boolean = false, showSuccessMessage: boolean = false, showCloseIcon: boolean = false) {
    return this.dialog.open(ConfirmationPopupComponent, {
      disableClose: false,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: buttonText,
        btn2BgColor: buttonColor,
        showSuccessIcon: showSuccessIcon,
        showSuccessMessage: showSuccessMessage,
        showCloseIcon: showCloseIcon
      }
    });
  }







  //  ============================================================ Training Calendar ================================================================================

  programList: string[] = ['Problem solving', 'Personal Develpoement'];
  statusList: string[] = ['Approved ', 'Rejected', 'Nominated']



  // ----------------- Headers of the Table ----------------------------------

  tableHeaders = [
    { label: 'Training Type', key: 'trainingType' },
    { label: 'Programme Title', key: 'title' },
    { label: 'Programme Code', key: 'code' },
    { label: 'LMS Link', key: 'lmsLink' },
    { label: 'Location', key: 'location' },
    { label: 'Start Date', key: 'startDate' },
    { label: 'End Date', key: 'endDate' },
    { label: 'Start Time', key: 'startTime' },
    { label: 'End Time', key: 'endTime' },
    { label: 'No. of Program Days', key: 'programDays' },
    { label: 'Functional/Behavioral', key: 'category' },
    { label: 'Dept.', key: 'department' },
    { label: 'Band', key: 'band' },
    { label: 'Grade', key: 'grade' },
    { label: 'Budget Cost', key: 'budgetCost' },
    { label: 'Actual Cost', key: 'actualCost' },
    { label: 'Faculty name', key: 'facultyname' },
    { label: 'Objective', key: 'objective' },
    { label: 'Action' }
  ];


  // ---------------------------- Employee Approval Table Header -----------------------

  employeeTableHeaders = [
    { label: 'Emp Code' },
    { label: 'Emp Name' },
    { label: 'Department' },
    { label: 'Band' },
    { label: 'Grade' },
    { label: 'Nominated By' },
    { label: 'Status' }
  ];







  // --------------------------- Faculty name pop-up inside the add program form ------------------------

  facultyNamePopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '70%';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(FacultyNamePopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

    });
  }


  // ------------------------- Edit program -------------------------------------------------------------

  editProgram(program: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    dialogConfig.disableClose = true;
    dialogConfig.data = { programData: program };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddProgramComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updated') {
        this.getAllProgramme();
      }
    });
  }


  //  ------------------------ Delete Progrm --------------------------------------------------------

  deleteProgram(program: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete Job Learning Feedback Form?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.httpService.callDeleteService(`${this.config.deleteTrainingProgram}${program.id}`)
          .subscribe(() => {
            this.getAllProgramme();
            this.openDialog('Deleted successfully', 'OK', this.buttonColorName, false, false, false);
          });
      }
    });
  }

  //  ---------------------------------------  get all Program --------------------------------------------------------

  programmeId: any;
  getAllProgramme() {
    let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;
    this.httpService.callGetService(this.config.getAllProgram + fiscal_year + "/" + year + "/" + companyId).subscribe((result: any) => {
      this.getProgramme = result.data;
      this.programmeId = result?.data[0]?.id;
      console.log("Get all programme====", this.getProgramme);

    })
  }


  // --------------------- add new program pop up ----------------------------------------------------

  onClickAddNewProgramPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddProgramComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

    });
  }



  // ========================================================Employee approval === Approve/ Reject Employees ====================================================
  
  selectedProgramId: any;
  status: any;

  approveSelected() {
    const selectedEmployees = this.allNominatedEmp.filter((emp: any) => emp.selected);

    if (selectedEmployees.length === 0) {
      this.toastr.warning('Please select at least one employee to nominate.', 'Warning');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Nominate?',
        btn1: 'Cancel',
        btn2: 'Confirm',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const userIds = selectedEmployees.map((emp: any) => emp.userId);

        const payload = {
          programId: this.programmeId,
          userIds: userIds,
          status: 'APPROVED',
        };
        this.httpService.callPostService(`${this.config.saveNominateStatus}`, payload)
          .subscribe((data: any) => {
            if (data) {
              this.toastr.success(data.message, 'Success');
              this.allNominatedEmp.forEach((emp: any) => {
                if (userIds.includes(emp.userId)) {
                  emp.status = 'APPROVED';
                  emp.selected = false;
                }
              });
              this.updateSelectionStatus();
            }
          },
            (error: any) => {
              this.toastr.error(error.error.error || 'An error occurred while processing your request.', 'Error');
            });

      }
    })

  }






  rejectSelected() {
    const selectedEmployees = this.allNominatedEmp.filter((emp: any) => emp.selected);

    if (selectedEmployees.length === 0) {
      this.toastr.warning('Please select at least one employee to nominate.', 'Warning');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Nominate?',
        btn1: 'Cancel',
        btn2: 'Confirm',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const userIds = selectedEmployees.map((emp: any) => emp.userId);

        const payload = {
          programId: this.programmeId,
          userIds: userIds,
          status: 'REJECTED',
        };
        this.httpService.callPostService(`${this.config.saveNominateStatus}`, payload)
          .subscribe((data: any) => {
            if (data) {
              this.toastr.success(data.message, 'Success');
              this.allNominatedEmp.forEach((emp: any) => {
                if (userIds.includes(emp.userId)) {
                  emp.status = 'REJECTED';
                  emp.selected = false;
                }
              });
              this.updateSelectionStatus();
            }
          },
            (error: any) => {
              this.toastr.error(error.error.error || 'An error occurred while processing your request.', 'Error');
            });

      }
    })
  }




  allNominatedEmp: any[] = []

  getAllNominatedEmp() {
    let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;
    this.httpService.callGetService(this.config.getAllNominateEmp + fiscal_year + "/" + year + "/" + companyId).subscribe((result: any) => {
      this.allNominatedEmp = result.data;
      console.log("Get all Nominated Employees====", this.allNominatedEmp);

    })
  }




  // Select/Deselect All
  selectAll(event: any) {
    const isChecked = event.checked;
    // this.allNominatedEmp.forEach((emp: any) => emp.selected = isChecked);
    this.allNominatedEmp.map((emp: any) => {
      return{

        ...emp,
      selected : emp.status !== 'NOMINATED'?false:isChecked
    }
     
      
    }
  );
    this.updateSelectionStatus();
  }


  isAnySelected = false;


  updateSelectionStatus() {
    this.isAnySelected = this.allNominatedEmp.some((emp: any) => emp.selected);
  }




  // =================== Dropdown for Department =======================================

  selectedDepartment: any = [];
  getDepartmentsList: any[] = [];

  dropdownSettings = {
    singleSelection: false,

    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  onDepartmentSelect() {

  }

  onDepartmentDeSelect() {

  }

  onDepartmentAllSelect() {

  }

  onDepartmentAllDeSelect() {

  }



  // ========================= Filters ==========================================
  filterEmployees() {
    // this.employees = this.filteredEmployees.filter((emp: any) =>
    //   emp?.firstName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    //   emp?.lastName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    //   emp?.salutation?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    //   emp?.status?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    //   emp?.candidateEmail?.toLowerCase().includes(this.searchTerm.toLowerCase())  // Adjust keys based on API response
    // );
    // console.log(this.employees);

  }

  // ============================ Show records ==============================
  DislaySelectedRecord(event: any) {
    // this.employees = this.filteredEmployees.slice(0, event.value);
  }

  // ========================== Download List ==================================

  downloadEmployeeList() {
    // if (!this.employees || this.employees.length === 0) {
    //   console.warn('No data available for export');
    //   return;
    // }

    // // Extract only the required fields
    // const filteredData = this.employees.map((employee: any) => ({
    //   Salutation: employee.salutation,
    //   FirstName: employee.firstName,
    //   LastName: employee.lastName,
    //   "Personal Email Id": employee.candidateEmail, // Fixed key with quotes
    //   Status: this.formatedataVariable(employee.status)
    // }));

    // // Convert to Excel format
    // const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    // const workbook: XLSX.WorkBook = { Sheets: { 'Employees': worksheet }, SheetNames: ['Employees'] };
    // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // // Convert to Blob and trigger download
    // const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    // FileSaver.saveAs(data, 'Employee_List.xlsx');
  }

}
